let french = {
  projects: 'PROJETS',
  exportlinks: 'LIENS EXPORT',
  newvideos: 'Créer VOD(s)',
  newlive: 'Créer Live',
  helpwsearch: 'Aide recherche',
  helpwsearchtxt: 'Filtrage sur le <strong>titre</strong> et les <strong>tags</strong> par défaut (si aucun mot-clé). <br /><br />Mots-clés pour recherche spécifique: <b>title</b>, <b>tags</b>, <b>id</b>, <b>status</b>, <b>description</b>. <br /><br />Utiliser <b>"+"</b> pour cumuler plusieurs paramètres pour un mot-clé. <br />Ex: tags:football<b>+</b>tennis. <br /><br />Mettre un <b>espace</b> pour une combinaison sur plusieurs critères. <br />Ex: title:MyMovie tags:vacances+été.',
  filter: 'Filtre',
  result: 'Résultat',
  imbmode: 'Mode imbriqué',
  imbmodetxt: 'Les <strong>archives VOD</strong> de vos lives et les <strong>Cuts</strong> créés à partir de vos VODs sont affichés dans un mode imbriqué et dans une taille + réduite pour faciliter la visualisation.<br /> Il ne sera pas possible de trier et filtrer dessus dans le mode imbriqué.<br /> Le tri et filtre ne seront appliqués que sur les flux Live et VODs originaux.<br /> Pour les appliquer sur tous, il faut sortir du mode imbriqué.',
  perpage: 'par page',
  selectsort: 'Faire le tri sur (scroll droite/gauche):',
  title: 'Titre',
  author: 'Auteur',
  creationdate: 'Date de création',
  duration: 'Durée',
  modifdate: 'Date de modif.',
  status: 'Statut',
  errors: 'Erreurs',
  qnbr: 'Qualités',
  viewingtime: 'Temps de visionnage total',
  viewers: 'Spectateurs',
  meanvd: 'Temps de visionnage moyen',
  topq: '% haute qualité',
  bitrate: 'Débit',
  rebuff: '% rechargement',
  eff: '% efficacité',
  dataout: 'Données',
  dataoutp: 'Données venant des viewers',
  energy: '% énergie sauvée',
  KWh: 'KWh dépensés',
  carbon: 'Carbone rejeté',
  tags: 'Tags',
  last24: 'Les données d\'analytics ici sont rafraichies toutes les 30min et concernent les dernières 24h: pour les observer en temps-réel, se rendre sur la page de la vidéo ou celle des Analytics.',
  logout: 'Exit QUANTEEC',
  logouttxt: 'Confirmez que vous voulez fermer la session QUANTEEC.',
  logoutbtn: 'Exit',
  cancel: 'Annuler',
  vidprev: 'Video preview',
  titlevid: 'Titre de la vidéo',
  authorvid: 'Auteur de la vidéo',
  novideos: 'Pas de videos',
  none: 'Aucun',
  typelive: 'Type de live',
  numberarch: 'Nombre archives',
  numbercut: 'Nombre cuts',
  chapterpresence: 'Présence de chapitres',
  videotype: 'Type de flux',
  dwnlfeature: 'Téléchargeable',
  uploadper: '% chargement',
  encodingper: '% encodage',
  uploadETA: 'Charg. ETA',
  encodeETA: 'Enc. ETA',
  allvids: 'Toutes les ',
  sortedby: ' videos triées par ',
  filtered: 'filtrées avec ',
  sby: 'triées par',
  legend: 'Légende',
  ongoingl: 'Live en cours',
  lstopped: 'Live arrêté',
  vod: 'VOD',
  archive: 'Archive',
  cutversion: 'Cuts',
  lwarch: 'Live avec Archives (mode imb.)',
  vodwcut: 'VOD avec Cuts (mode imb.)',
  archwcut: 'Archive avec Cuts (mode imb.)',
  selected: 'Sélectionnée(s): ',
  show: 'Montrer',
  hide: 'Cacher',
  selectall: 'Toutes',
  last: 'Dernier',
  by: 'Par',
  top: 'Premier',
  playable: '(visionnable)',
  encoding: 'en encodage',
  uploading: 'en chargement...',
  uploadfailed: 'chargement échoué',
  restarting: 'redémarrage...',
  stopped: 'arrêté',
  encoded: 'encodé',
  error: 'erreur',
  waiting: 'en attente...',
  deletenow: 'La vidéo va maintenant être supprimée',
  nodate: 'Pas de date',
  watch: 'Regarder',
  videod: 'Video(s) - suppression',
  delete: 'Supprimer',
  confirmd: 'Merci de confirmer la suppression de la vidéo: ',
  confirmdall: 'Merci de confirmer la suppression de <strong>toutes</strong> les vidéos sélectionnées.<br /><br /> Merci de vous assurer que cette vidéo n\'est pas liée à un (ou plusieurs) projet(s). <br />La vidéo ne pourra pas être récupérée.',
  confirmd2: 'Merci de vous assurer que cette vidéo n\'est pas liée à un (ou plusieurs) projet(s). <br />La vidéo ne pourra pas être récupérée.',
  processingvids: 'Redémarrage du process',
  customQ: 'Qualités spécifiques',
  relaunch: 'Relancer le process',
  relaunchconfirmall: 'Merci de confimer le lancement du ré-encodage de <strong>toutes</strong> les vidéos sélectionnées.',
  relaunchconfirm: 'Merci de confimer le lancement du ré-encodage de ',
  modifyencp: 'Modifier les paramètres d\'encodage',
  nodelayo: 'Mode zéro-délai (5 spectateurs max.)',
  mixdelay: 'Mode zéro-délai pour les 5 premiers + bas-délai pour les suivants',
  lowdelay: 'Mode bas-délai (large audience)',
  qencmethod: 'Méthode d\'encodage des qualités',
  defaultenc: '(par défaut/recommandé)',
  pttext: 'Rendre les vidéos visionnables immédiatement en mode passthrough, pendant l\'encodage (phase durant au minimum la durée de la vidéo). <br />Une fois finalisées, les versions encodées vont automatiquement remplacées la version passthrough.',
  confbelow: '(à configurer ci-dessous)',
  sameaso: '(identique à l\'original, pas de qualité additionnelle)',
  addq: 'Ajouter une qualité et ajuster vos paramètres*',
  addqe: 'Ajouter une qualité à encoder',
  specificQ: '*Pour des paramètres d\'encodage spécifiques, merci de contacter QUANTEEC: support@quanteec.com',
  encprocstop: 'Arrêt du process d\'encodage',
  encprocstopconf: 'Merci de confirmer l\'arrêt du process de ré-encodage',
  stopproc: 'Arrêter le process',
  videoprocresterr: 'Redémarrage du process: <span style="color:red">error</span>',
  restartliveserr: 'Vous ne pouvez pas redémarrer plusieurs lives provenant de la même webcam.',
  iframecode: 'Copie code iFrame',
  iframecodetxt: 'Le code iFrame de la vidéo: ',
  clip: ' est copié dans le presse-papier.',
  directlink: 'Copie lien direct',
  directlinktxt: 'Lien direct de la vidéo: ',
  delayeddesplan: 'Planification de la destruction de vidéo',
  delayeddesplantxt: 'Merci de confirmer la planification de la destruction de <strong>toutes</strong> les vidéos sélectionnées à la date de: ',
  delayedreason: 'La date entrée est antérieure ou très proche de la date/heure actuelle. Les vidéos sélectionnées vont immédiatement être détruites.',
  confirm: 'Confirmer',
  close: 'Fermer',
  delayedtime: 'Les vidéos vont être supprimées à la date/heure spécifiée - erreur(s): ',
  delayeddeserr: 'Planification de destruction: <span style="color:red">erreur</span>',
  delayeddeserr2: 'Erreur lors de la planification de destruction de la vidéo ',
  delayeddesclear: 'Planification de destruction: annuler date(s)',
  delayeddescleardates: 'Les dates de suppression des vidéos sélectionnées ont été annulées - erreur(s): ',
  delayeddescleardateserr: 'Planification de destruction: annuler date - <span style="color:red">erreur</span>',
  delayeddescleardateserrtxt: 'Erreur lors de l\'annulation des dates de destruction',
  //PLAYERPAGE
  projectsuv: 'Projet(s) utilisant cette vidéo*',
  desc: 'Description:',
  currentv: 'Version courante:',
  createnp: 'Créer un nouveau projet à partir de cette vidéo',
  onlyp: '*Seulement les projets auxquels vous participez sont enumérés ici.',
  videoinfos: 'Video - infos',
  totalld: 'Durée totale du live',
  type: 'Type',
  ongoingls: 'Flux Live en cours',
  vodcp: 'VOD, en cours de process...',
  ls: 'Flux Live',
  archivefl: 'Archive d\'un Live',
  livess: 'Flux Live, arrêté',
  vodff: 'VOD',
  livess30: 'Flux Live, démarrage (30s max)...',
  vodupl: 'VOD, upload en cours...',
  liveerr: 'Flux Live, erreur',
  voderr: 'VOD, erreur',
  livespro: 'Flux Live, en cours de process...',
  vodpro: 'VOD, en cours de process...',
  fromc: 'Issu d\'une caméra',
  fromss: 'Issu d\'un logiciel de diffusion',
  customs: 'Flux custom',
  keptasvod: 'Gardé en tant que VOD',
  notkeptasvod: 'NON gardé en tant que VOD',
  vodarchivestxt: '<b>Les archives VOD</b> sont créées automatiquement à chaque fois que vous arrêtez la diffusion ou quand rien n\'est reçu pendant 1min. Aucune restriction dans la relance de flux, après qu\'il ait été stoppé.',
  changingpara: 'Changer ce paramètre pendant l\'<span style="color:#ba0000">encodage</span> redémarre le process. Le flux ne sera pas disponible pendant 30s au minimum. <br />Ce paramètre utilise votre stockage.',
  createnewVODs: 'Créer de nouvelles VODs coupées à partir de l\'original avec des timeframes différents. 2 modes: <br><b>Précis</b>: la vidéo va respecter exactement le timeframe mais sa création durera au minimum la durée de la vidéo<br><b>Rapide</b>: la vidéo va respecter approximativement le timeframe - variation de qq sec tout au plus - mais sa création sera instantanée.',
  existingcv: 'Versions Cut existantes',
  start: 'Début:',
  end: 'Fin:',
  accurate: 'Précis',
  fast: 'Rapide',
  cutsmode: 'Mode de création des versions Cuts',
  accuratemodetxt: '<b>Précis</b>: la vidéo va respecter exactement le timeframe mais sa création durera au minimum la durée de la vidéo<br><b>Rapide</b>: la vidéo va respecter approximativement le timeframe - variation de qq sec tout au plus - mais sa création sera instantanée.',
  existingVODa: 'Archives existantes',
  downlallo: 'Téléchargement autorisé pour toutes les archives',
  downlnotallo: 'Téléchargement NON autorisé pour toutes les archives',
  starting: 'démarrage',
  custom: 'Custom',
  qualityaso: 'Qualité (similaire à l\'original)',
  qualities: 'Qualités:',
  copy: 'Copier',
  copied: 'Copié',
  sourcec: 'Source connectée',
  sourcedis: 'Source déconnectée',
  time: 'Time:',
  videobr: 'Vidéo débit:',
  audiobr: 'Audio débit:',
  modifyes: 'Modifier flux externes',
  startstr: 'Démarrer flux',
  stopstr: 'Arrêter flux',
  extstrstat: 'Flux externes - statut global:',
  disnevstart: 'Déconnecté - jamais démarré',
  liveperlivestat: 'Flux externes - statuts (la màj peut prendre qq sec):',
  connected: 'Connecté',
  disconnected: 'Déconnecté',
  customwm: 'Texte watermark:',
  iframecode: 'iFrame code:',
  iframecodetxt: 'Code de l\'iFrame pour intégrer le player vidéo responsive dans une page html.',
  directl: 'Lien direct:',
  directltxt: 'Lien direct vers une page web intégrant le player pour cette vidéo.',
  exportl: 'Lien d\'export',
  exportltxt: 'Code de l\'iFrame pour intégrer le player vidéo du lien d\'export au sein d\'une page web.',
  manageel: 'Gérer les liens d\'export',
  videoparam: 'Vidéos - paramètres',
  plandst: 'Planifier un départ différé: ',
  plandsttxt: 'Le démarrage de la vidéo est planifié pour:',
  fromthecre: 'Depuis la création',
  selectdate: 'Sélectionner une date',
  setup: 'Setup',
  modify: 'Modifier',
  clear: 'Effacer',
  selectdateprior: 'La date sélectionnée est antérieure (ou proche) à la date actuelle. La vidéo va être immédiatement mise disponible.',
  videodel: 'La vidéo va être détruite avant d\'être mise à disposition des spectateurs.',
  plandd: 'Planifier une suppression différée:',
  videoplandd: 'La vidéo va être supprimée à la date de:',
  nodates: 'Aucune date spécifiée',
  selectdatedel: 'La date sélectionnée est antérieure (ou proche) à la date actuelle. La vidéo va être immédiatement détruite.',
  videoselectdatedel: 'La vidéo va être détruite avant d\'être mise à disposition aux spectateurs.',
  chatliveact: 'Le chat vidéo va être activé pour cette vidéo.',
  chatlivedesact: 'Le chat vidéo NE va PAS être activé pour cette vidéo.',
  passwdprot: 'La vidéo est protégée par un mot de passe.',
  passwdnotprot: 'La vidéo N\'est PAS protégée par un mot de passe.',
  modifypwd: 'Modifier mot de passe',
  removepwd: 'Enlever mot de passe',
  addpwd: 'Ajouter mot de passe',
  viewersauth : 'Les spectateurs sont autorisés à revenir en arrière lors de leurs sessions Live - non disponible pour les spectateurs zero-délai',
  viewersnotauth: 'Les spectateurs NE sont PAS autorisés à revenir en arrière lors de leurs sessions Live',
  securecode: 'La camera est limitée à une IP',
  nosecurecode: 'la camera N\'est PAS limitée à une IP',
  nbrofstk: 'Nombre de secondes à garder (min: 30 - max: 600):',
  videodwnl: 'La vidéo peut être téléchargée',
  videonotdwnl: 'La vidéo NE peut être téléchargée',
  videoautolaunch: 'La vidéo est lancée automatiquement (son off)',
  videonotautolaunch: 'La vidéo N\'est PAS lancée automatiquement. Les spectateurs doivent appuyer sur le bouton Play.',
  videointromodal: 'Les informations sont affichées au lancement de la vidéo',
  videonotintromodal: 'Les informations NE sont PAS affichées au lancement de la vidéo',
  modifyct: 'Modifier custom thumbnail',
  custimizet: 'Customiser thumbnail',
  removect: 'Supprimer custom thumbnail',
  chapters: 'Chapitres: ',
  chapter: 'chapitre(s)',
  nochapter: 'Aucun chapitre',
  uplchapter: 'Fichier de chapitres',
  addchapman: 'Ajouter un chapitre manuellement',
  vodacc: 'VoD(s) depuis mon Live accéléré',
  dnwlQP: 'Télécharger la vidéo au sein de QUANTEEC Platform',
  videoshar: 'Video - partage',
  videoanalytics: 'Video - analytics',
  sourcePathModified: 'La source du live a été modifiée. Merci de redémarrer le processus d\'encodage et les diffusion externes (vers Youtube, FB, etc) pour que le changement soit pris en compte.',
  //ANALYTICS
  videos4all: 'Video(s) - * pour tout',
  byid: 'Par ID',
  or: 'ou',
  selectvid: 'Sélectionner vidéo(s)',
  interval: 'Intervalle:',
  timerange: 'Période:',
  views: 'Visionnage',
  allvids2: '- toutes les vidéos',
  ofthetime: 'du temps en meilleure qualité',
  ofeff: 'd\'éfficacité',
  ofener: 'd\'énergie sauvée',
  viewersmax: 'spectateurs max',
  totalvt: 'Temps de visionnage total',
  maxavgv: 'Spectateurs max. (moy.)*',
  maxavgcv: 'Spectateurs max. (moy.)*',
  plays: 'Plays',
  meanvt: 'Durée moy. de visionnage',
  viewersvalues: '*Les valeurs liées au "nombre de spectateurs" sont affichées en tant que moyenne du nombre de spectateurs en simultané sur l\'intervalle. Réduire l\'intervalle pour avoir des valeurs + précises.',
  meanvtvalues: 'Les valeurs de la "durée moyenne de visionnage" sont calculées en fonction de la période choisie.',
  quality: 'Qualité',
  highq: 'Hautes qualités %*',
  highqdata: 'Hautes qualités - données*',
  lowqdata: 'Basses qualités - données*',
  avgvb: 'Débit vidéo moyen',
  rebuffering: 'Rechargement',
  rebuffmin: 'Rechargement - temps:',
  playedmin: 'Temps de lecture total',
  videodata: '*Les données vidéo sont considérées de "hautes qualités" quand la résolution de la qualité en cours est + grande (ou égale) à la taille de l\'écran ou si la qualité en cours est la + haute disponible pour la vidéo.',
  efficiency: 'Efficacité*',
  effnote: '*L\'efficacité est le % de données reçues des autres spectateurs par rapport aux données totales.',
  effdata: 'Efficacité',
  effdataco: 'Efficacité - connectés',
  efftime: 'Efficacité (temps)',
  totaldatadel: 'Total données délivrées',
  delfromp: 'Depuis spectateurs',
  delfroms: 'Depuis CDN',
  ener: 'Énergie*',
  energynote: '*Toutes les données liées à l\'énergie ont été estimées en fonction des recommandations tirées des études ci-dessous.',
  energynote2: 'Base des estimations: données \"monde\". Pour l\'Europe, diviser les valeurs liées au Carbone par 1.6. Pour la France, diviser les valeurs liées au Carbone par 7.',
  lightexp: ' - équivalent à l\'énergie sauvée en éteignant <span style="color:#14BF98;font-weight:bold">1</span> ampoule de 30-Watts pendant une heure.',
  houseexp: ' - équivalent à l\'énergie sauvée en coupant toute l\'électricité consommée par <span style="color:#14BF98;font-weight:bold">1</span> habitation pendant une journée.',
  enersaved: 'Énergie sauvée %',
  connview: 'Spectateurs connectés uniquement',
  enersavedConnected: 'Énergie sauvée - connectés',
  poweren: 'Énergie consommée',
  delivery: '(diffusion)',
  powerens: 'Énergie sauvée',
  powerend: 'Énergie consommée',
  viewing: '(visionnage)',
  co2rej: 'CO2 rejeté',
  co2saved: 'CO2 sauvé',
  watercon: 'Eau consommée',
  watersav: 'Eau sauvée',
  selectvidana: 'Sélectionner les vidéos pour afficher leurs analytics',
  viewtimemobile: 'Visionnage sur mobile',
  viewtimetablet: 'Visionnage sur tablette',
  viewtimedesktop: 'Visionnage sur autres',
  viewtimeeth: 'Visionnage via autres',
  viewtimecellular: 'Visionnage via rsx mobiles',
  map: 'Carte des données spectateurs',
  //EXPORT LINKS
  newel: 'Nouveau Lien Export',
  copyonelink: 'Copier <span style="color:#14BF98">un lien</span>, partager les <span style="color:#14BF98">vidéos</span> que vous voulez.',
  exportvids: 'Exporter vos videos vers votre site en utilisant les <strong style="color:#14BF98">LIENS EXPORT</strong> customisables de QUANTEEC.',
  exportlink: 'Les <strong style="color:#14BF98">LIENS EXPORT</strong> vous permettent de copier un seul lien dans votre site ou application web. Ensuite, vous pouvez revenir sur cette page et modifier la vidéo associée à ce lien unique.',
  exportl: 'Lien(s) Export',
  exportl1: 'Lien Export',
  copytc: 'Copier ce code au sein de votre page html pour exporter le player vidéo pour la vidéo associée',
  videolinked: 'Vidéo associée:',
  novideolinked: 'Aucune vidéo associée',
  dissociate: 'Dissocier une vidéo',
  deletel: 'Supprimer Lien Export',
  associate: 'Associer une vidéo',
  errorposttxt: 'Ce nouveau Lien Export ne peut être créé. Merci de réessayer plus tard ou contacter QUANTEEC à support@quanteec.com.',
  errorgettxt: 'La liste des Liens Export ne peut être récupérée. Merci de réessayer plus tard ou contacter QUANTEEC à support@quanteec.com.',
  errorputtxt: 'Le Lien Export ne peut être mis à jour. Merci de réessayer plus tard ou contacter QUANTEEC à support@quanteec.com.',
  errordeltxt: 'Le Lien Export ne peut être supprimé. Merci de réessayer plus tard ou contacter QUANTEEC à support@quanteec.com.',
  viddel: 'Suppression Lien Export',
  confirmdel: 'Merci de confirmer la suppression de: ',
  linkrecnot: 'Le lien ne peut être récupéré.',
  selectel: 'Sélectionner le flux vidéo à associer au Lien Export: ',
  videoifcode: 'Code iFrame du Lien Export',
  ifcodeel: 'Code iFrame du Lien Export pour la vidéo: ',
  iscopied: 'copié.',
  //PROFIL
  
  clientinfo: 'CLIENT - INFORMATIONS',
  clientnbr: 'Client - Numéro:',
  contractnbr: 'Contrat - Numéro:',
  companyname: 'Nom de l\'entreprise:',
  siret: 'SIRET:',
  contactname: 'Nom du contact:',
  contact1stname: 'Prénom du contact:', 
  email: 'Email:',
  phone: 'Téléphone:',
  postaladdr: "Adresse postale:",
  accountinfo: 'COMPTE - INFORMATIONS',
  username: 'Nom d\'utilisateur:',
  invalidemail: 'Format d\'email invalide',
  enterpass: 'Entrer votre mot de passe pour changer votre email',
  updateemail: 'Mettre à jour email',
  newpass: 'Nouveau mot de passe*:',
  enternpass: 'Entrer nouveau mot de passe',
  pass7: 'Les mots de passe doivent contenir au minimum: 7 caractères, une lettre minuscule, une lettre majuscule, un chiffre, un caractère spécial.',
  confirmpass: 'Confirmer nouveau mot de passe',
  passident: 'Les mots de passe doivent être identiques',
  enterold: 'Entrer votre mot de passe actuel pour valider les changements',
  updatepass: 'Mise à jour mot de passe',
  wishalert: 'Je souhaite recevoir les alertes emails en cas de problèmes de diffusion',
  wishnotalert: 'Je ne souhaite pas recevoir les alertes emails en cas de problèmes de diffusion',
  apidoc: 'API - documentation',
  collab: 'COLLABORATEURS',
  createcollab: 'Créer',
  docs: 'DOCUMENTS',
  bills: 'Factures:',
  odocs: 'Autres documents:',
  unsub: 'RESILIER ABONNEMENT',
  deleteclient: 'Supprimer le compte client et toutes les données',
  deleteclienttxt: 'La suppression de votre compte et de toutes vos données est planifiée pour la fin de votre engagement. Cliquez sur le bouton ci-dessous si vous changez d\'avis.',
  canceldel: 'Annuler résiliation du compte. Garder le compte client et toutes les données',
  collabdel: 'Suppression du collaborateur',
  confirmcollabdel: 'Merci de confirmer la suppression du collaborateur:',
  makesure: 'Merci de vous assurer que ce collaborateur n\'est pas lié à un ou plusieurs projet(s).',
  norecover: 'Le collaborateur ne peut être récupéré.',
  claccdel: 'Suppression du compte client',
  claccdelconfirm: 'Merci de confirmer la suppression du compte et de toutes les données attachées (collaborateurs, vidéos et projets). <br>Tout sera supprimé à la fin de votre engagement.<br /><br /> En cas de changement d\'avis, merci de contacter QUANTEEC à l\'adresse suivante: <span style="color: #2f90b0">contact@quanteec.com</span> (ou cliquer sur le bouton "Garder compte")',
  passwdmodif: 'Modification du mot de passe',
  passwdmodiftxt: 'Le mot de passe a été correctement modifié.',
  errpassmod: 'Erreur lors de la modification de mot de passe',
  errpassmodtxt: 'Le mot de passe n\'a pas été correctement sauvé. Merci de recommencer + tard ou contacter QUANTEEC à: support@quanteec.com',
  erroldpass: 'Erreur mot de passe ou modification d\'email',
  erroldpasstxt: 'Votre mot de passe actuel est incorrect. Votre mot de passe ou votre email n\'a pas été modifié.',
  keepclacc: 'Garder compte client',
  keepclacctxt: 'Merci de confirmer que vous voulez garder votre compte.',
  erremail: 'Erreur email',
  erremailtxt: 'Cette adresse email est déjà utilisée par un autre compte.',
  erremailtxt2: 'Erreur dans la modification de l\'email.',
  verifemail: 'Email de vérification envoyé',
  verifemailtxt: 'Un email de vérification a été envoyé. <br><br>Merci de valider ce nouvel email afin d\'utiliser QUANTEEC. Le lien est valable 24h.',
  newcollab: 'Création d\'un nouveau collaborateur.',
  param: 'PARAMÈTRES PAR DÉFAUT',
  titledp: 'Ces paramètres seront utilisés par défaut en créant une nouvelle vidéo.', 
  //USER FORM
  collab1: 'Collaborateur',
  collabname: 'Entrer nom du collaborateur',
  collabemail: 'Enter email du collaborateur',
  randompass: '*Un mot de passe généré aléatoirement va être envoyé par email',
  accmgrrights: 'Droits complets sur toutes les fonctionnalités du compte, des collaborateurs, et des vidéos',
  videomgrrights: 'Droits complets sur toutes les fonctionnalités liées aux vidéos seulement',
  addcollab: 'Ajouter un collaborateur',
  createcollab: 'Créer nouveau collaborateur',
  reset: 'Reset',
  errcollabc: 'Erreur lors de la création du collaborateur',
  errcollabctxt: 'Impossible de créer le nouveau collaborateur. Merci de réessayer plus tard ou de contacter QUANTEEC à: support@quanteec.com.',
  errcollabcemailtxt: 'Cet email est déjà utilisé par un collaborateur.',
  errcollabcunametxt: 'Ce nom d\'utilisateur <span style="color: #2F90B0"><strong>{{newCollaborators}}</strong></span> est déjà pris.<br />Vous pouvez utiliser <span style="color: #2F90B0"><strong>{{newCollaborators}}</strong></span> à la place.',
  newcollabc: 'Nouveau collaborateur créé',
  newcollabctxt: 'Collaborateur <span style="color: #2F90B0"><strong>{{newCollaborators}}</strong></span> a bien été créé. <br /><span style="color: #2F90B0"><strong>{{newCollaborators}} </strong></span> va recevoir un email avec ses informations.',
  //VIREED TEAM
  teams: 'EQUIPES',
  norights: 'Interdiction de modifier',
  createnewt: 'Créer une nouvelle équipe',
  teaminfos: 'Equipe - Infos',
  teamembers: 'Equipe - Membres',
  addtotheteam: 'Ajouter à l\'équipe',
  create: 'Créer',
  reset: 'Reset',
  members: 'Membres',
  teamdel: 'Suppression de l\'équipe',
  teamdeltxt: 'Merci de confirmer la suppression de l\'équipe :',
  teamdeltxt2: 'Assurez vous que cette équipe n\'est pas liée à un ou plusieurs projets.<br> L\'équipe de peut être récupérée.',
  alreadym: 'est déjà membre de cette équipe.',
  //PLUGIN DOC
  yourpersonalkey: 'Votre clé QUANTEEC par défaut :',
  videoplayerdoc: 'Doc du player vidéo',
  visualizationtooldoc: 'Doc de l\'outil de visualisation',
  needacdn: "Besoin d'un CDN également ?",
  selectvideoplayer: 'Sélectionnez le lecteur de vidéos dans lequelle vous voulez intégrer QUANTEEC',
  watchonce: 'Une fois fait, regardez au moins une fois vos vidéos pour qu\'elles apparaissent dans l\'onglet Vidéos',
  brightcovecodep1: 'Captures d\'écran de la configuration du player Brightcove pour intégrer <strong> QUANTEEC</strong>',

  //DOC Plugin
  plugininstallfromCDN: "Installation depuis un CDN",
  plugininstallfromNPM: "Installation avec NPM",
  pluginp1: 'Récupérez le fichier javascript <strong>QUANTEEC</strong> <a href="https://files.quanteec.com/quanteec/latest/videojs-quanteec-plugin.js" > ici </a> pour l\'intégrer avec <a href="https://videojs.com">video.js</a>. Suivez ensuite ces 4 étapes simples :',
  pluginp1_1: 'Récupérez le fichier javascript <strong>QUANTEEC</strong> <a href="https://files.quanteec.com/quanteec/latest/quanteec-vhs.min.js" > ici </a> pour l\'intégrer avec <a href="https://videojs.com">video.js</a>. Suivez ensuite ces 3 étapes simples :',
  pluginp2: 'Récupérez le fichier javascript <strong>QUANTEEC</strong> <a href="https://files.quanteec.com/quanteec/latest/quanteec-hlsjs.min.js" > ici </a> pour l\'intégrer avec <a href="https://github.com/video-dev/hls.js/">hls.js (à partir de v0.13.2)</a>. Suivez ensuite ces 3 étapes simples :',
  pluginp3: 'Récupérez le fichier javascript <strong>QUANTEEC</strong> <a href="https://files.quanteec.com/quanteec/latest/quanteec-dashjs.min.js" > ici </a> pour l\'intégrer avec <a href="https://github.com/Dash-Industry-Forum/dash.js/wiki">dash.js (à partir de v2.6.0)</a>. Suivez ensuite ces 3 étapes simples :',
  pluginp4: 'Récupérez le fichier javascript <strong>QUANTEEC</strong> <a href="https://files.quanteec.com/quanteec/latest/quanteec-shaka.min.js" > ici </a> pour l\'intégrer avec <a href="https://github.com/shaka-project/shaka-player">shaka player</a>. Suivez ensuite ces 3 étapes simples :',
  pluginp5: 'Récupérez le fichier javascript <strong>QUANTEEC</strong> <a href="https://files.quanteec.com/quanteec/latest/quanteec-hlsjs.min.js" > ici </a> pour l\'intégrer avec <a href="https://flowplayer.com">flowplayer</a> 7. Suivez ensuite ces 4 étapes simples :',
  pluginp6: 'Récupérez le fichier javascript <strong>QUANTEEC</strong> <a href="https://files.quanteec.com/quanteec/latest/quanteec-hlsjs.min.js" > ici </a> pour l\'intégrer avec <a href="https://flowplayer.com">flowplayer</a> native.  Suivez ensuite ces 5 étapes simples :',
  pluginp7: 'Récupérez le fichier javascript <strong>QUANTEEC</strong> <a href="https://files.quanteec.com/quanteec/latest/videojs-quanteec-plugin.js" > ici </a> pour l\'intégrer avec <a href="https://brightcove.com">Brightcove</a>. Suivez ensuite ces 3 étapes simples :',
  pluginjwp1: 'Récupérez le fichier javascript <strong>QUANTEEC</strong> <a href="https://files.quanteec.com/quanteec/latest/jwplayer.quanteec.js" > ici </a> pour l\'intégrer avec <a href="https://jwplayer.com/web-player/">JW Player</a>. Suivez ensuite ces 3 étapes simples :',
  pluginp8: 'Ajoutez le script dans votre page html',
  pluginp9: 'Ajoutez le fichier videojs-quanteec-plugin.js dans la section Plugins, en-dessous de JavaScript/Javascript URL',
  pluginp10: 'Ajoutez <strong>quanteec</strong> dans la section Plugins, sous Name, Options (JSON)/Plugin Name',
  pluginp11: 'Ajustez la configuration de QUANTEEC en mettant votre quanteecKey et des options spécifiques',
  pluginp12: 'Liez QUANTEEC à l\'objet video.js *avant* la création de l\'instance du player videojs',
  pluginp13: 'Enregistrez le plugin QUANTEEC dans videojs',
  pluginp14: 'Liez QUANTEEC à hls.js juste *après* la création de l\'instance du player hls.js',
  pluginp1_2: 'Liez QUANTEEC au player videojs juste *après* la création de l\'instance du player',
  pluginp15: 'Liez QUANTEEC à dash.js juste *après* la création de l\'instance du player dash.js',
  pluginp16: 'Liez QUANTEEC à shakaplayer juste *après* la création de l\'instance de shakaplayer',
  pluginp17: 'Liez QUANTEEC à flowplayer juste *avant* la création de l\'instance de flowplayer',
  pluginp18: 'Ajoutez ces paramètres dans les options de flowplayer',
  pluginp19: 'Déclarez votre instance flowplayer à QUANTEEC pour pouvoir monitorer l\'état du buffer et permettre au plugin de sélectionner la qualité optimale.',
  pluginp20: 'Ajustez la configuration de Quanteec en y mettant votre quanteecKey et des options spécifiques dasn la section Plugins, sous Name, Options (JSON)/plugin options (au format JSON',
  pluginp21: 'Récupérez le fichier javascript  <strong>QUANTEEC</strong> <a href="https://files.quanteec.com/quanteec/latest/quanteec-rxplayer.min.js" > ici </a> pour l\'intégrer avec <a href="https://github.com/canalplus/rx-player">rxPlayer</a>. Suivez ensuite ces 3 étapes simples :',
  pluginp22: 'Récupérez le fichier javascript  <strong>QUANTEEC</strong> <a href="https://files.quanteec.com/quanteec/latest/quanteec-bitmovin.min.js" > ici </a> pour l\'intégrer avec <a href="https://bitmovin.com/video-player/">Bitmovin</a>. Suivez ensuite ces 3 étapes simples :',
  pluginp23: 'Liez QUANTEEC à rxPlayer juste *après* la création de l\'instance de rxPlayer',
  pluginp24: 'Liez QUANTEEC à bitmovin juste *avant* la création de l\'instance de bitmovin',
  pluginjwp3: 'Liez QUANTEEC à JwPlayer juste *après* le setup de l\'instance de JWPlayer',
  pluginrmp1: 'Récupérez le fichier javascript  <strong>QUANTEEC</strong> <a href="https://files.quanteec.com/quanteec/latest/quanteec-radiantmediaplayer.min.js" > ici </a> pour l\'intégrer avec <a href="https://www.radiantmediaplayer.com/">Radiant Media Player</a>. Suivez ensuite ces 3 étapes simples :',
  pluginrmp3: 'Liez QUANTEEC à Radiant Media Player juste *après* le setup de l\'instance de Radiant Media Player',
  pluginexo1: 'Pour intégrer QUANTEEC dans votre application Android avec Exoplayer, suivez ces 4 étapes :', 
  dash_example: 'Exemple de fichier index.html utilisant Dash.js et intégrant <strong>QUANTEEC</strong> sans DRM.',
  dash_examplewDRM: 'Exemple de fichier index.html utilisant Dash.js et intégrant <strong>QUANTEEC</strong> avec DRM. La documentation se trouve <a href="https://github.com/Dash-Industry-Forum/dash.js/wiki/Digital-Rights-Management-(DRM)-and-license-acquisition"> ici</a>.',
  bitmovin_example: 'Exemple de fichier index.html utilisant Bitmovin player et intégrant <strong>QUANTEEC</strong> sans DRM.',
  bitmovin_examplewDRM: 'Exemple de fichier index.html utilisant Bitmovin player et intégrant <strong>QUANTEEC</strong> avec DRM. La documentation se trouve <a href="https://bitmovin.com/docs/player/tutorials/streaming-drm-protected-content-with-bitmovin-player-web-sdk"> ici</a>.',
  flow_example: 'Exemple de fichier index.html utilisant Flowplayer Native et intégrant <strong>QUANTEEC</strong> sans DRM.',
  flow_examplewDRM: 'Exemple de fichier index.html utilisant Flowplayer Native et intégrant <strong>QUANTEEC</strong> avec DRM. La documentation se trouve <a href="https://docs.flowplayer.com/plugins/drm"> ici</a>.',
  flow7_example: 'Exemple de fichier index.html utilisant Flowplayer 7 et intégrant <strong>QUANTEEC</strong> avec DRM. Les DRMs ne sont disponibles que dans la version Native de Flowplayer.',
  hlsjs_example: 'Exemple de fichier index.html utilisant hls.js et intégrant <strong>QUANTEEC</strong> sans DRM.',
  hlsjs_examplewDRM: 'Exemple de fichier index.html utilisant hls.js et intégrant <strong>QUANTEEC</strong> avec DRM. Seulement Widevine est supporté. La documentation se trouve <a href="https://github.com/video-dev/hls.js/blob/master/docs/API.md#widevineLicenseUrl"> ici</a>.',
  rmp_example:"Exemple de fichier index.html utilisant Radiant Media Player et intégrant <strong>QUANTEEC</strong>.",
  vjs_example: 'Exemple de fichier index.html utilisant video.js et intégrant <strong>QUANTEEC</strong> sans DRM.',
  vjs_examplewDRM: 'Exemple de fichier index.html utilisant video.js et intégrant <strong>QUANTEEC</strong> avec DRM. La documentation se trouve <a href="https://github.com/videojs/videojs-contrib-eme"> ici</a>.',
  rxp_example: 'Exemple de fichier index.html utilisant rxPlayer et intégrant <strong>QUANTEEC</strong> sans DRM.',
  rxp_examplewDRM: 'Exemple de fichier index.html utilisant rxPlayer et intégrant <strong>QUANTEEC</strong> avec DRM. La documentation se trouve <a href="https://developers.canal-plus.com/rx-player/doc/Getting_Started/Tutorials/Content_with_DRM.html"> ici</a>.',
  shaka_example: 'Exemple de fichier index.html utilisant Shaka Player et intégrant <strong>QUANTEEC</strong> sans DRM.',
  shaka_examplewDRM: 'Exemple de fichier index.html utilisant Shaka Player et intégrant <strong>QUANTEEC</strong> avec DRM. La documentation se trouve <a href="https://shaka-player-demo.appspot.com/docs/api/tutorial-drm-config.html"> ici</a>.',
  jwp_example: 'Exemple de fichier index.html utilisant JW Player et intégrant <strong>QUANTEEC</strong>.',

  pleaseretry: 'Please retry later',
  plugint1: 'QUANTEEC Visualization tool',
  exampledrm: 'Exemple avec DRM',
  examplenodrm: 'Exemple sans DRM',

  vjsexample: 'Exemple d\'un fichier index.html utilisant Video.js and et intégrant **QUANTEEC** sans DRM.',
  hlsExampledrm: 'Exemple d\'un fichier index.html utilisant Hls.js et intégrant **QUANTEEC** sans DRM.',
  hlsExamplenodrm: 'Exemple d\'un fichier index.html utilisant Hls.js et intégrant **QUANTEEC** avec DRM. Only Widevine DRM is supported. More information can be found [here](https://github.com/video-dev/hls.js/blob/master/docs/API.md#widevineLicenseUrl).',
  dashexamplenodrm: 'Exemple d\'un fichier index.html utilisant Dash.js et intégrant QUANTEEC sans DRM.',
  dashexampledrm: 'Exemple d\'un fichier index.html utilisant Dash.js et intégrant QUANTEEC avec DRM. Documentation can be found here.',
  rxnodrm: 'Exemple d\'un fichier index.html utilisant rxPlayer et intégrant QUANTEEC avec DRM.',
  rxdrm:'Exemple d\'un fichier index.html utilisant rxPlayer et intégrant QUANTEEC avec DRM. Documentation can be found here.',
  bitmovinnodrm:'Exemple d\'un fichier index.html utilisant bitmovin et intégrant QUANTEEC sans DRM.',
  bitmovindrm:'Exemple d\'un fichier index.html utilisant bitmovin et intégrant QUANTEEC avec DRM. Documentation can be found here.',
  shakanodrm:'Exemple d\'un fichier index.html utilisant Shaka player et intégrant QUANTEEC sans DRM.',
  shakadrm:'Exemple d\'un fichier index.html utilisant shaka player et intégrant QUANTEEC avec DRM. The documentation can be found here',
  flowplayernodrm:'Exemple d\'un fichier index.html utilisant Flowplayer et intégrant QUANTEEC sans DRM.',
  flowplayerdrm:'Exemple d\'un fichier index.html utilisant Flowplayer et intégrant QUANTEEC avec DRM. The documentation can be found here.',
  flowplayer7nodrm:'Exemple d\'un fichier index.html utilisant Flowplayer et intégrant QUANTEEC sans DRM. DRM is possible only avec the native version of Flowplayer.',
  brightcexample:'Capture d\'écran de la configuration du player Brightcove pour intégrer QUANTEEC',
  jwplayerexample:'Exemple d\'un fichier index.html utilisant JWPlayer et intégrant QUANTEEC.',

  //PLUGIN DOC NPM
  pluginp1npm: 'Pour installer et utiliser QUANTEEC avec <a href="https://videojs.com">video.js</a> en utilisant npm, suivez ces étapes : ',
  pluginp1_1npm: 'Pour installer et utiliser QUANTEEC avec <a href="https://videojs.com">video.js</a> en utilisant npm, suivez ces étapes :',
  pluginp2npm: 'Pour installer et utiliser QUANTEEC avec <a href="https://github.com/video-dev/hls.js/">hls.js (v0.13.2 et +)</a> en utilisant npm, suivez ces étapes :',
  pluginp3npm: 'Pour installer et utiliser QUANTEEC avec <a href="https://github.com/Dash-Industry-Forum/dash.js/wiki">dash.js (v2.6.0 et +)</a> en utilisant npm, suivez ces étapes :',
  pluginp4npm: 'Pour installer et utiliser QUANTEEC avec <a href="https://github.com/shaka-project/shaka-player">shaka player</a> en utilisant npm, suivez ces étapes :',
  pluginp5npm: 'Pour installer et utiliser QUANTEEC avec <a href="https://flowplayer.com">flowplayer</a> 7 en utilisant npm, suivez ces étapes :',
  pluginp6npm: 'Pour installer et utiliser QUANTEEC avec <a href="https://flowplayer.com">flowplayer</a> native en utilisant npm, suivez ces étapes :',
  pluginp7npm: 'Pour installer et utiliser QUANTEEC avec <a href="https://brightcove.com">Brightcove</a> en utilisant npm, suivez ces étapes :',
  pluginjwp1npm: 'Pour installer et utiliser QUANTEEC avec <a href="https://jwplayer.com/web-player/">JW Player</a> en utilisant npm, suivez ces étapes :',
  pluginp21npm: 'Pour installer et utiliser QUANTEEC avec <a href="https://github.com/canalplus/rx-player">rxPlayer</a> en utilisant npm, suivez ces étapes :',
  pluginp22npm: 'Pour installer et utiliser QUANTEEC avec <a href="https://bitmovin.com/video-player/">Bitmovin</a> en utilisant npm, suivez ces étapes :',
  pluginrmp1npm: 'Pour installer et utiliser QUANTEEC avec <a href="https://www.radiantmediaplayer.com/">Radiant Media Player</a> en utilisant npm, suivez ces étapes :',

  pluginloginnpm : 'Connectez-vous au dépôt npm de QUANTEEC en utilisant le nom d\'utilisateur et le mot de passe qui vous ont été fournis par e-mail',
  loginnpmcode : 'npm login --registry https://npm.quanteec.com:4873/  ',
  plugininstallnpm: 'Installez le package QUANTEEC',
  installnpmpackage: 'npm install @quanteec/quanteec-plugin --registry https://npm.quanteec.com:4873/',
  pluginimportnpm: 'Importez le plugin QUANTEEC',
  pluginimporthlsjsnpm: 'import Quanteec from "@quanteec/quanteec-plugin/quanteec-hlsjs.min"',
  pluginimporthvideoJSsnpm: 'import Quanteec from "@quanteec/quanteec-plugin/videojs-quanteec-plugin.min"',
  pluginimporthvideovhssnpm: 'import Quanteec from "@quanteec/quanteec-plugin/quanteec-vhs.min"',
  pluginimporthvideodashnpm: 'import Quanteec from "@quanteec/quanteec-plugin/quanteec-dashjs.min"',
  pluginimporthvideorxsnpm: 'import Quanteec from "@quanteec/quanteec-plugin/quanteec-rxplayer.min"',
  pluginimporthvideobitmovinsnpm: 'import Quanteec from "@quanteec/quanteec-plugin/videojs-bitmovin.min"',
  pluginimporthvideoshakanpm: 'import Quanteec from "@quanteec/quanteec-plugin/quanteec-shaka.min"',
  pluginimporthvideojwpsnpm: 'import Quanteec from "@quanteec/quanteec-plugin/jwplayer.quanteec.min"',
  pluginimportrmpnpm: 'import Quanteec from "@quanteec/quanteec-plugin/quanteec-radiantmediaplayer.min"',

  //CDN DOC
  needatradcdn: 'Vous avez également besoin d\'un CDN traditionnel ?',
  cdnagnostic: 'est compatible avec tous les CDN majeurs du marché. Par exemple :',
  wecanmanage: 'Nous pouvons aussi gérer un CDN pour vous avec un de nos partenaires. L\'utilisation de ce CDN est sans surcoût additionnel: 10€ / To.',
  //CDN DOC 2
  programcachetitle: 'Paramétrez vos options de cache pour améliorer la qualité de votre diffusion vidéo par CDN',
  programcachep1: 'Les session de streaming en DASH et HLS utilisent deux types de fichiers. Les <strong>manifests</strong> (au format .mpd or .m3u8) et les fichiers <strong>vidéo</strong> (aux formats .mp4, .webm, .ts). Alors que les fichiers <strong>vidéos</strong> peuvent être gardés en cache pendant de longues périodes, les <strong>manifests</strong> doivent être revalidés régulièrement sur des périodes assez courtes, en particulier pour les sessions en direct.',
  programcachet2: 'Paramètres de cache recommandés',
  programcachep2: 'Pour les  <strong style="color:#14BF98">manifests</strong> et les fichiers <strong style="color:#14BF98">vidéos</strong>, nous recommandons de mettre l\'en-tête <strong>Cache-Control</strong> à la valeur <strong>must-revalidate</strong> avec un attribut <strong>max-age</strong>. Cette en-tête permet d\'indiquer au navigateur web de garder les ressources en mémoires pendant un certain temps avant de revalider les fichiers avec le serveur au bout de <strong>max-age</strong> secondes. Si les ressources n\'ont pas été modifiées, le serveur va retourner une réponse  <strong>NOT MODIFIED</strong> sans renvoyer les données. Ce comportement permet d\'optimiser l\'utilisation du cache tout en assurant un bon affichage des données à jour.',
  programcachep3: 'Pour les <strong style="color:#14BF98">manifests</strong>, nous recommendons de bien revalider les ressources avec un max-age égale à la durée de vos plus petits segments (en secondes). Par exemple, pour des segments vidéo de 3 secondes :',
  programcachep4: 'Pour les fichiers <strong style="color:#14BF98">vidéo</strong>, les ressources peuvent être conservées en cache pendant des durée bien plus longues, qui dépendent de vos besoin. Par exemple :',
  programcachet3: 'Exemple avec Nginx',
  programcachet4: 'Exemple avec Apache',
  // CustomCDN.vue
  originurl: 'Url d\'origine',
  newurl: 'Nouvel url',
  cdnprice: 'Prix HT',
  actions: 'Actions',
  TBunit: 'To',
  TBstarted: 'Mois en cours (à partir du 1er). Tout To commencé est dû.',
  minTB: '*Prix fixe: 250€ HT jusqu\'à 50 To',
  cdnblockedips: 'Adresses IP bloquées',
  cdnblockedcountries: 'Pays bloqués',
  cdnwhitelistedwebsites: 'Sites web autorisées',
  cdnblacklistedwebsites: 'Sites web non-autorisés',
  addcdn: 'Ajouter un CDN',
  customcdnp1: 'Pour diffuser votre vidéo via le CDN, vous avez simplement besoin de remplacer les URLS pointant vers vos fichiers vidéos avec la <strong>Nouvelle url</strong>. Vos données vidéos vont être automatiquement récupérées, mises en cache et délivrées à travers le CDN.',
  customcdnp2: 'Par exemple, modifier l\'URL des fichiers vidéos pointant vers :',
  customcdnp3: 'vers votre <strong>nouvel url</strong> :',
  customcdnp4: 'Les vidéos peuvent être visionnées depuis n\'importe quelle adresse IP, à l\'EXCEPTION de celles dans la liste ci-dessous. Vous pouvez aussi bloquer un sous-réseau entier avec par exemple 91.212.45.*',
  customcdnp5: 'Les vidéos peuvent être visionnées depuis n\'importe quel pays, à l\'EXCEPTION de ceux dans la liste ci-dessous. Utilisez les <a href="https://www.iso.org/obp/ui/fr/#search" target="_blank">code ISO 3166 Alpha-2</a>.',
  customcdnp6: 'Les vidéos peuvent être visionnées depuis n\'importe quel site web INCLUS dans la liste ci-dessous. Vous pouvez aussi ajouter un sous-domaine entier avec par exemple *.quanteec.com.',
  customcdnp7: 'Les vidéos peuvent être visionnées depuis n\'importe quel site web, à l\'EXCEPTION de ceux dans la liste ci-dessous. Vous pouvez aussi bloquer un sous-domaine entier avec par exemple *.quanteec.com.',
  customcdnp8: 'Les changement peuvent mettre quelques secondes à être appliqués.',
  Submit: 'Envoyer',
  Success: 'Succès',
  selectedtextcopied: 'Le texte sélectionné a été copié',
  cachepurged: 'Le cache a été purgé. Les fichiers vont être rechargés d\'ici quelques secondes.',
  cdncontractsigned: 'Les liens CDN sont limités aux clients enregistrés avec un abonnement actif. Vous pouvez activer votre accès complet à toutes les fonctionnalités dans votre page profil.',
  //PLUGIN PRICE
  priceestcalc: '€ Calculateur de prix',
  enternbrTB: 'Nombre de To* :',
  price: 'Prix (HT)* :',
  priceperTB: 'Prix (HT) par To :',
  producttitle: 'PRODUIT',
pldatadelivered: 'Données distribuées* :',
  lastdatadelivered: 'Le mois dernier :',
  lastprice: 'Prix le mois dernier :',
  GBunit: 'Go',
  TBunit: 'To',
  currentprice: 'Prix (HT)* :',
  pricinglist: 'Liste des prix (HT)',
  termsofservice: 'Conditions Générales d\'Utilisation',
  accepttermsofservice: 'J\'accepte les Conditions Générales d\'Utilisation et les tarifs',
  acceptcontract: 'Générer le contrat',
  peradditional: 'tous les',
  contractaccepted: 'Génération du contrat',
  welcome: 'Merci d\'avoir choisi QUANTEEC. Votre contrat est en cours de génération. Il apparaîtra bientôt dans la section Documents ci-dessous.',
  uploadRIB: 'Merci de déposer votre RIB ou de l\'envoyer à l\'adresse :',
  errorcontract: 'Merci de réessayer plus tard ou de contacter Quanteec à l\'adresse :',
  Error: 'Erreur',
  rib: 'RIB:',
  bankreceived: 'RIB reçu',
  chooseRIB: 'Choisissez un RIB...',
  uploadbankdet: 'Déposer le RIB',
  modifybankdetails: 'RIB reçu. Pour le modifier, contactez Quanteec à l\'adresse :',
  chargedon5: 'Ce montant sera facturé au 5 du mois suivant.',
  restant: 'dans',
  nextlevel: 'Prochain pallier ',
  previousbillings: 'Afficher les factures précédentes',
  hidebillings: 'Fermer l\'historique de consommation',
  free: 'Gratuit (en mode Demo)',
  only: 'Seulement',
  leftfree: 'restant dans l\'offre gratuite',
  enterpaymentdetail: 'Entrer les informations de paiement',
  billingpanel: 'Panneau de facturation',
  consumptionhistory: 'Historique de consommation',
  // VISUALIZATION TOOL DOC
  visutoolbook1: 'Installer en tant que Bookmarklet',
  visutoolbook2: 'Un bookmarklet est un petit morceau de code JavaScript qui peut être enregistré comme un favori dans votre navigateur web. Lorsque vous cliquez sur le bookmarklet, il exécute le code JavaScript, vous permettant d\'effectuer des actions spécifiques ou des améliorations sur la page web actuelle. L\'outil de visualisation Quanteec peut être enregistré en tant que bookmarklet pour afficher les graphiques sur n\'importe quelle page où le plugin Quanteec est installé.',
  visutoolbook3: 'Ouvrez votre navigateur web (par exemple, Chrome, Firefox, Safari). Faites un clic droit sur la barre des favoris et ouvrez le gestionnaire de favoris. Sélectionnez l\'option pour créer un nouveau favori. Vous pouvez également utiliser le menu du navigateur pour créer un nouveau favori.',
  visutoolbook4: 'Dans la boîte de dialogue de création de favori, donnez un nom significatif à votre bookmarklet.',
  visutoolbook5: 'Dans le champ URL, placez le code JavaScript suivant :',
  visutoolbook6: 'Cliquez sur le bouton "Enregistrer" ou "Ajouter" pour sauvegarder le bookmarklet.',
  visutoolbook7: 'Maintenant, rendez-vous sur une page intégrant le plugin Quanteec et cliquez sur le nouveau lien en favori pour ouvrir les graphiques.',
  visutoolt1: 'Installation',
  visutoolp1: 'Récupérez le fichier javascript de l\'outil de visualisation QUANTEEC <a href="https://files.quanteec.com/vizualisation/latest/quanteec-visualize.min.js" > ici</a>. Puis, insérez les deux lignes suivantes dans le fichier HTML où le plugin QUANTEEC a déjà été installé : ',
  visutoolli1: 'Ajoutez le script dans votre code HTML',
  visutoolli2: 'Ajoutez un div avec un id égal à "quanteec-visualization-tool" dans le corps de votre document HTML',
  visutoolp2: 'Après cela, des données et graphiques devraient apparaître.',
  visutoolt2: 'Personnalisation',
  visutoolp3: 'En fonction de l\'espace alloué à l\'outil sur votre page, vous pouvez modifier la taille de la police d\'écriture de base de l\'outil en spécifiant un "font-size" dans l\'attribut "style" du div',
  visutoolp4: 'Par défaut, les métriques et les graphiques sont tous affichés. Il est possible de réduire les graphiques en ajoutant un attribut <strong>quanteecShow=“less”</strong>. Les graphiques en question sont alors remplacés par un bouton permettant de les afficher/masquer.',
  visutoolp5: 'Il est possible de personnaliser le div "quanteec-visualize-tool" (comme toutes les balises div), par exemple en fixant une "max-size" pour limiter la taille de l\'outil dans votre page.',
    //VISUALIZATION TOOL ANDROID DOC
    visutoolt1exo: 'Installation',
    visutoolp1exo: 'Récupérez l\'outil de visualisation de QUANTEEC pour Android en suivant ces 3 étapes',
    visutoolp1exoJ: 'Récupérez l\'outil de visualisation de QUANTEEC pour Android en suivant ces 4 étapes',
    visutoolli1exo: 'Ajoutez les dépots suivants dans le fichier setting.gradle ou build.gradle : ',
    visutoolli2exo: 'Ajoutez la dépendance suivante dans le fichier build.gradle : ',
    visutoolli3exo: 'Dans le code de votre application, ajoutez le code suivant afin d\'instancier et d\'afficher l\'outil : ',
    visutoolp2exo: 'Après cela, des données et graphiques devraient apparaître.',

    //VISUALIZATION TOOL JAVA
    visutoolli25exoJava: 'Créer une ComposeView pour afficher l\'outil : ',
  
  //PLUGIN-VIDEO
  loadnewvideos: "Chercher de nouvelles vidéos",
  activelast2min: "Vidéo regardée durant les 2 dernières min",
  refresh: "Rafraîchir",
  showhidden: "Afficher les vidéos cachées",
  showactiveonly: "Afficher uniquement les vidéos avec une activité récente",
  last24p: 'Les données sur la qualité et les métriques affichées dans chaque vidéo ci-dessous sont rafraîchit toutes les 30 min et représentent les dernières 24h. Pour les voir en temps réel ou sur une période spécifique, allez dans la page des Analytics',
  pluginvideop1: 'Le filtre fonctionne sur les titres et les tags par défaut (si aucun mot clé n\'est mentionné).',
  pluginvideop2: 'Les mots clé valide pour des recherches spécifiques sont : title, tags, id, description.',
  pluginvideop3: 'Utilisez \'+\' pour cumuler plusieurs paramètres pour un mot clé Ex: tags:football+tennis.',
  pluginvideop4: 'Utilisez un espace pour faire une recharche combinant plus d\'un critère. Ex: title:MyMovie tags:vacation+summer.',
  pluginvideoplural: 'vidéo(s)',
  pluginvideoauthip: 'IP autorisées :',
  pluginvideounauthip: 'IP non autorisées :',
  pluginvideoauthsubdomain: 'Sous-domaines autorisés :',
  pluginvideounauthsubdomain: 'Sous-domaines non autorisés :',
  pluginvideoauthcountry: 'Pays autorisés :',
  pluginvideounauthcountry: 'Pays non autorisés :',
  smallnone: 'aucun',
  pluginvideoice: 'Configuration ICE :',
  pluginvideolocalnet: 'Réseau local uniquement',
  pluginvideothumbnail: 'URL d\'image personnalisée :',
  pluginvideoauthorizations: 'Autorisations :',
  pluginvideostreamed: 'La vidéo peut être lue',
  pluginvideonotstreamed: 'La vidéo ne peut pas être lue',
  pluginvideoauthip2: '@ IP autorisées ',
  pluginvideounauthip2: '@ IP non autorisées',
  pluginvideop5: 'La vidéo peut-être lue UNIQUEMENT par une des adresse IP de la liste ci-dessous.<br />Si la liste est vide, les vidéos peuvent être lues depuis n\'importe quelle adresse IP.',
  pluginvideop6: 'La vidéo peut être regardée depuis n\'importe quelle adresse IP, à l\' EXCEPTION de celles dans la liste ci-dessous.',
  pluginvideoauthsubdomaine2: '@ Sous-domaines autorisés ',
  pluginvideounauthsubdomain2: '@ Sous-domaines non autorisés',
  pluginvideosubdomainunauth: 'The video can be watched from any subdomain, EXCEPT the ones on the list below.',
  pluginvideosubdomainauth: 'La vidéo peut-être lue UNIQUEMENT par un des sous-domaines de la liste ci-dessous.<br />Si la liste est vide, les vidéos peuvent être lues depuis n\'importe quelle sous-domaines.',
  pluginvideop6: 'La vidéo peut être regardée depuis n\'importe quel sous-domaine, à l\' EXCEPTION de ceux dans la liste ci-dessous.',
  pluginvideoauthcountry2: 'Pays autorisés',
  pluginvideounauthcountry2: 'Pays non autorisés',
  pluginvideop7: 'La vidéo peut être lue UNIQUEMENT depuis les pays dans la liste ci-dessous. <br />Si la liste est vide, la vidéo peut être lue depuis n\'importe quel pays. Utilisez les codes <a href="https://www.iso.org/obp/ui/fr/#search" target="_blank">ISO 3166 Alpha-2</a>.',
  pluginvideop8: 'La vidéo peut être lue depuis n\'importe quel pays, à l\'EXCEPTION de ceux de la liste ci-dessous. Utilisez les codes <a href="https://www.iso.org/obp/ui/fr/#search" target="_blank">ISO 3166 Alpha-2</a>.',
  pluginvideowhitewb: 'Sites web autorisés',
  pluginvideoblackwb: 'Sites web non autorisés',
  pluginvideop9: 'La vidéo peut être lue UNIQUEMENT depuis les sites présent dans la liste ci-dessous.<br />Si la lidte est vide, la vidéo peut être lue depuis n\'importe quel site.',
  pluginvideop10: 'La vidéo peut être lue depuis n\'importe quel site web, à l\'EXCEPTION de ceux de la liste ci-dessous.',
  pluginvideoiceconf: 'Configuration ICE :',
  pluginvideodefault: 'QUANTEEC (par défaut)',
  pluginvideoicecustom: 'Configuration ICE personnalisée',
  pluginvideobound: 'Suit les autorisations par défaut',
  pluginvideoisauthst: 'diffusion autorisée',
  pluginvideoisnotauthst: 'diffusion non autorisée',
  videopluginvpn: 'VPNs et proxy autorisés',
  videopluginnotvpn: 'VPNs et proxy non autorisés, à l\'exception de :',
  pluginvideoenterurlthumb: 'Entrer l\'URL de la thumbnail',
  pluginvideoisauthorized : 'Diffusion autorisée',
  pluginvideoisnotauthorized: 'Diffusion non autorisée',
  pluginvideoisvpn: 'Les VPNs et proxy sont autorisés',
  pluginvideoisnotvpn: 'Les VPN et proxy ne sont pas autorisés, à l\'exception de :',
  pluginvideoaddstun: 'Ajouter STUN',
  pluginvideoaddturn: 'Ajouter TURN',
  pluginvideovalidate: 'Valider',
  pluginvideoresetdefault: 'Rétablir les valeurs par défaut',
  // PAYMENT SUCCESS
  successpayment: 'Paiement réussi',
  paymentsuccessp1: 'Vous pouvez commencer à utiliser QUANTEEC.',
  failurepayment: 'Paiement échoué ou abandonné',
  paymentfailurep1: 'Vous pouvez continuer à utiliser QUANTEEC pendant votre offre gratuite. En cas de problème avec le paiement, vous pouvez contacter QUANTEEC à l\'adresse',

  supportedDRM : 'QUANTEEC est compatible avec les DRM suivants :',

  resetTags : 'Réinitialisation des tags',
  resetCollections: 'Réinitialisation des collections',
  //OUTRO
  modifyoutro: 'Modifier l\'appel à l\'action',
  removeoutro: 'Supprimer l\'appel à l\'action',
  outro: 'Appel à l\'action',
  outrotitle: "Titre ",
  outrodescription: "Description ",
  outrourl: "Lien du bouton",
  outrotext: "Texte du bouton",
  outroimg: "Image",
  outrourl2: "Lien du sous-texte",
  outrotext2: "Sous-texte",
  backgroundoutro: "Image d'arrière plan",
  outrocurrentimg: "Image d'appel à l'action actuelle",
  helptag:"Aide avec les tags",
  helptagtxt:"Filtrer les vidéos à partir des tags qui leur sont associés en cliquant dessus.<br /> Les tags en <strong>bleu</strong> ne sont pas sélectionnés dans la recherche.<br/> Les tags en <strong>vert</strong> signifie qu'ils sont selectionées, la rechercher affichera alors les vidéos qui contiennent un ou plusieurs de ces tags. <br /> Les tags en <strong>rouge</strong> signifie qu'il sont exclus de la recherche, les vidéos possédant un ou plusieurs de ces tags n'apparaîtront pas.",
  generatethumbnailfrompicture: "Créer une miniature à cette image de la vidéo",
  createthumbnail: "Créer la miniature",
  errorcreatethumbnail: "Erreur à la création de la miniature. Merci de réessayer plus tard.",
  successcreatethumbnail: "La nouvelle miniature a été générée",
  adddefaultoutro: "Insérer un appel à l'action pré-configuré",
  addnewoutro: "Modifier l'appel à l'action",
  outrodeleteconfirm: "Êtes-vous sûrs de vouloir supprimer cet appel à l'\'action ? Les appels à l\'action supprimés ne peuvent pas être récupérés.",
  outrodeleteerror: "Erreur pendant la suppression. Merci d'essayer à nouveau plus tard.",
  // Pictures
  picturestitle: "BANQUE D'IMAGES",
  picture: "Images",
  pictureuploadsuccess: "La nouvelle image a été ajoutée avec succès",
  pictureuploaderror: "Erreur pendant l'ajout. Merci d'essayer à nouveau plus tard",
  picturedeleteconfirm: "Êtes-vous sûrs de vouloir supprimer cette image ? Les images supprimées ne peuvent pas être récupérées.",
  picturedeleteerror: "Erreur pendant la suppression. Merci d'essayer à nouveau plus tard.",
  addapicture: "Ajouter une image",
  // APIKEY
  apikeystitle: "CLÉS D\'API",
  apikey: "Clés d\'Api",
  apikeyuploadsuccess: "La nouvelle clé a été ajoutée avec succès",
  apikeyuploaderror: "Erreur pendant la création. Merci d'essayer à nouveau plus tard.",
  apikeydeleteconfirm: "Êtes-vous sûrs de vouloir supprimer cette clé ? Les clés supprimées ne peuvent pas être récupérées.",
  apikeydeleteerror: "Erreur pendant la suppression. Merci d'essayer à nouveau plus tard.",
  addaapikey: "Ajouter une clé d'api",
  createapikey: "Ajouter une clé d'api",
  // DEFAULT OUTRO
  defaultoutrotitle: "COLLECTION D'APPELS À L\'ACTION",
  addanoutro: "Ajouter un appel à l'action",
  modifyoutro: "Modifier l'appel à l'action sélectionné",
  //REPLACE
  replacevideo: "Remplacer la vidéo",
    // PLATFORM PRICE
    month: "mois",
    storage: "Stockage :",
    datadelivered: 'Données distribuées :',
    concurrentencodings: 'Encodages concurrents :',
    baseprice: "Prix HT de base :",
    pricethismonth: 'Prix HT ce mois-ci :',
    bulbsText: 'Equivalent à: ',
    bulbs: 'amploules ',

  //CONFIG PAGE
  selectconfig:"Selectionner une configuration",
  newconfig: "Nouvelle configuration",
  deleteconfig:"Supprimer la configuration selectionnée",
  newecdn: "Nouvelle configuration",
  config1:"Configuration",
  config2:"Nom",
  configname:"Nom de la configuration",
  createconfig:"Créer",
  yes:"Oui",
  no:"Non",
  configdelete:"Confirmer supression",
  deleteconfirm1:"Vous êtes sur le point de supprimer la configuration ",
  deleteconfirm2:"le confirmez-vous ?",

  //CONFIGSITE PAGE
  configHeader:"Configuration",
  quanteecKeyconfig:"Clé QUANTEEC :",
  keyexplainconfig:"Cette <strong>clé QUANTEEC</strong> remplace celle par défaut si vous souhaitez utiliser les authorisations et configurations ECDN qui y sont associées.",
  authorizationheaderconfig:"Authorisations",
  siteListConfig:"Liste des sites",
  siteexplainConfig:"Utilisez cette page pour créer vos configurations P2P globales, ou liées à des sites et sous-domaines.",
  acceptundeclaresite:"Authoriser les peers de sites non déclarés ? (les peers de sites non déclarés ne seront pas groupés avec les peers des sites existant)",
  loadingConfig:"Chargement...",

}

  export {french}